import DilemmasChart from "./dilemmas-chart";
import UsersChart from "./users-chart";

const GraphStats = () => {
  return (
    <div className="flex-1 flex w-full flex-col gap-4">
      <DilemmasChart />
      <UsersChart />
    </div>
  );
};

export default GraphStats;
